import { DateRange } from '../../../../apis/graphql/types';
import { SelectProps } from '../../../../components/BlueTheme/DatePicker/utils';

export const MILISECONDS_IN_HOUR = 60000;
export const MILISECONDS_IN_WEEK = 6 * 24 * 60 * MILISECONDS_IN_HOUR;

export const countDateRange = (range?: string): Date[] | undefined => {
  const yesterday = getYesterday();
  switch (range) {
    case DateRange.CurrentMonth:
      return [new Date(yesterday.getFullYear(), yesterday.getMonth()), yesterday];
    case DateRange.CurrentYear:
      return [new Date(yesterday.getFullYear(), 0), yesterday];
    case DateRange.Last_7Days:
      const countTimeZoneOffset =
        yesterday.getTimezoneOffset() - new Date(yesterday.getTime() - MILISECONDS_IN_WEEK).getTimezoneOffset();
      const startDate = new Date(yesterday.getTime() - MILISECONDS_IN_WEEK - countTimeZoneOffset * MILISECONDS_IN_HOUR);
      startDate.setHours(0, 0, 0, 0);
      return [startDate, yesterday];
    case DateRange.PreviousMonth:
      const now = new Date();
      const previousMonth = new Date(now.getFullYear(), now.getMonth() - 1, 1);
      const startDay = new Date(previousMonth.getFullYear(), previousMonth.getMonth(), 1);
      const lastDay = new Date(previousMonth.getFullYear(), previousMonth.getMonth() + 1, 0);
      return [startDay, lastDay];
    default:
      return undefined;
  }
};

export const getYesterday = (): Date => {
  const today = new Date();
  const yesterday = new Date(today);

  yesterday.setDate(today.getDate() - 1);
  yesterday.setHours(0, 0, 0, 0);

  return yesterday;
};

export const getDateYearAgoFromToday = (): Date => {
  const today = new Date();
  return new Date(today.getFullYear() - 1, today.getMonth(), today.getDate());
};

export const getTwoYearsRange = (): SelectProps[] => {
  const today = new Date();
  const prevYear = String(today.getFullYear() - 1);
  const currentYear = String(today.getFullYear());

  return [
    { value: prevYear, label: prevYear },
    { value: currentYear, label: currentYear },
  ];
};

export const getMinAvailableDate = (): Date => {
  const yearAgo = new Date(new Date().setFullYear(new Date().getFullYear() - 1));
  yearAgo.setHours(0, 0, 0, 0);

  return yearAgo;
};
